import { inject, Injectable } from '@angular/core';
import { IAddress } from '../../../models/address.model';
import { RegisteredAddress } from '../../../models/registered-address.model';
import { COUNTRIES } from '../../../models/constants/countries.const';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class BaryAddressUtil {
  readonly #translateService = inject(TranslateService);

  updateGmapsAddressString(value?: IAddress): string | undefined | RegisteredAddress {
    if (value) {
      const result = '';
      return result
        .concat(value.streetNumber ? value.streetNumber + ' ' : '')
        .concat(value.street ? value.street : '')
        .concat((value.streetNumber || value.street) && value.zipCode ? ', ' : '')
        .concat(value.zipCode ? value.zipCode : '')
        .concat((value.streetNumber || value.street || value.zipCode) && value.city ? ', ' : '')
        .concat(value.city ? value.city : '')
        .concat((value.streetNumber || value.street || value.zipCode || value.city) && value.country ? ', ' : '')
        .concat(value.country ? this.#translateService.instant(COUNTRIES[value.country].translationKey) : '');
    } else {
      return value;
    }
  }

  updateGmapsAddressStringWithRegisteredAddress(value?: RegisteredAddress): string | undefined | RegisteredAddress {
    if (value) {
      const result = '';
      return result
        .concat(value.alias ? value.alias + ', ' : '')
        .concat(value.streetNumber ? value.streetNumber + ' ' : '')
        .concat(value.street ? value.street : '')
        .concat((value.streetNumber || value.street) && value.zipCode ? ', ' : '')
        .concat(value.zipCode ? value.zipCode : '')
        .concat((value.streetNumber || value.street || value.zipCode) && value.city ? ', ' : '')
        .concat(value.city ? value.city : '')
        .concat((value.streetNumber || value.street || value.zipCode || value.city) && value.country ? ', ' : '')
        .concat(value.country ? this.#translateService.instant(COUNTRIES[value.country].translationKey) : '');
    } else {
      return value;
    }
  }

  writeAddress(value: IAddress): string {
    let result = '';
    if (value.fullname) {
      result += value.fullname + '<br/>';
    }
    if (value.streetNumber || value.street || value.additionals) {
      if (value.streetNumber) {
        result += value.streetNumber + ', ';
      }
      if (value.street) {
        result += value.street;
      }
      if (value.additionals) {
        result += ', ' + value.additionals;
      }
      result += '<br/>';
    }
    if (value.zipCode) {
      result += value.zipCode + ', ';
    }
    if (value.city) {
      result += value.city;
    }
    if (value.country) {
      result += ', ' + this.#translateService.instant(COUNTRIES[value.country].translationKey);
    }
    return result;
  }
}
